// tslint:disable jsx-no-lambda
import * as classNames from "classnames";
import * as React from "react";
import { alertsClasses as myClasses } from "src/controllers/alerts";

import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { alertComposeActions } from "src/actions";

import { IMessageDetailsProps, MessageDetails } from "./message-details";

import {
  IMultiMediaProps,
  MultiMedia
} from "src/controllers/alerts/components";

import "./styles.css";

export interface IComposeMessageProps
  extends IMessageDetailsProps,
    IMultiMediaProps {
  multiMediaClicked: (
    type: string,
    state: string
  ) => (dispatch: Dispatch<any>) => Promise<void>;
  removeFile: (name: string) => (dispatch: Dispatch<any>) => Promise<void>;
  updateMultiMediaState: (
    state: string
  ) => (dispatch: Dispatch<any>) => Promise<void>;
  toggleMoreInfo: (
    type: string,
    screen: string
  ) => (dispatch: Dispatch<any>) => Promise<void>;
  messageDetailsInputChanged: (
    type: string,
    value: string
  ) => (dispatch: Dispatch<any>) => Promise<void>;
  recordAudio: (type: string) => (dispatch: Dispatch<any>) => Promise<void>;
  uploadMultiMedia: (
    files: any,
    id: string
  ) => (dispatch: Dispatch<any>) => Promise<void>;
}

class ComposeMessage extends React.Component<IComposeMessageProps> {
  public constructor(props: IComposeMessageProps) {
    super(props);
    this.onMessageDetailsInputChanged = this.onMessageDetailsInputChanged.bind(
      this
    );
    this.onToggleMoreInfo = this.onToggleMoreInfo.bind(this);
    this.onMultiMediaClicked = this.onMultiMediaClicked.bind(this);
    this.onMultiMediaStateChange = this.onMultiMediaStateChange.bind(this);
    this.onMultiMediaOnDrop = this.onMultiMediaOnDrop.bind(this);
    this.onRecordAudio = this.onRecordAudio.bind(this);
    this.onRemoveFile = this.onRemoveFile.bind(this);
  }

  public render() {
    const { messageDetails, multiMedia } = this.props;

    return (
      <div className={classNames(myClasses.ALERTS_CONTENT_COMPOSE_MESSAGE)}>
        <MessageDetails
          messageDetails={messageDetails}
          onMessageDetailsInputChanged={this.onMessageDetailsInputChanged}
          onToggleMoreInfo={this.onToggleMoreInfo}
          multiMedia={multiMedia}
          onRemoveFile={this.onRemoveFile}
        />
        <MultiMedia
          multiMedia={multiMedia}
          onMultiMediaClicked={this.onMultiMediaClicked}
          onMultiMediaOnDrop={this.onMultiMediaOnDrop}
          onRecordAudio={this.onRecordAudio}
          onMultiMediaStateChange={this.onMultiMediaStateChange}
        />
      </div>
    );
  }

  private onRemoveFile(event: any, name: string) {
    this.props.removeFile(name);
  }

  private onMultiMediaOnDrop(files: any, id: string) {
    this.props.uploadMultiMedia(files, id);
  }

  private onRecordAudio(event: any, type: string) {
    this.props.recordAudio(type);
  }

  private onMultiMediaStateChange(event: any, state: string) {
    this.props.updateMultiMediaState(state);
  }

  private onMultiMediaClicked(event: any, type: string, state: string) {
    this.props.multiMediaClicked(type, state);
  }

  private onToggleMoreInfo(event: any, type: string) {
    this.props.toggleMoreInfo(type, "compose-message");
  }

  private onMessageDetailsInputChanged(event: any, type: string) {
    const value = event.currentTarget.value;
    this.props.messageDetailsInputChanged(type, value);
  }
}

const mapStateToProps = (state: any) => {
  const { alerts } = state;
  const { composeData } = alerts;
  const { composeMessage } = composeData;
  const { messageDetails, multiMedia } = composeMessage;

  return {
    messageDetails,
    multiMedia
  };
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    messageDetailsInputChanged: bindActionCreators(
      alertComposeActions.onComposeMessageUpdateInput,
      dispatch
    ),
    recordAudio: bindActionCreators(
      alertComposeActions.onComposeMessageRecordAudio,
      dispatch
    ),
    toggleMoreInfo: bindActionCreators(
      alertComposeActions.onToggleMoreInfo,
      dispatch
    ),
    multiMediaClicked: bindActionCreators(
      alertComposeActions.onComposeMessageMultiMediaClicked,
      dispatch
    ),
    updateMultiMediaState: bindActionCreators(
      alertComposeActions.onComposeMessageUpdateMultiMediaState,
      dispatch
    ),
    uploadMultiMedia: bindActionCreators(
      alertComposeActions.onComposeMessageUploadMultiMedia,
      dispatch
    ),
    removeFile: bindActionCreators(
      alertComposeActions.onComposeMessageRemoveMultiMedia,
      dispatch
    )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ComposeMessage);



// WEBPACK FOOTER //
// ./src/controllers/alerts/compose/compose-message/compose-message.tsx